import { configureStore } from '@reduxjs/toolkit';
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  batch,
} from 'react-redux';

import { listeningSlice } from './slice/listening';
import {readingSlice} from './slice/reading';
import { writingSlice } from './slice/writing';
import { userSlice } from './slice/user';
import { examSlice } from './slice/exam';
import { pointsSlice } from './slice/pointsSlice';
// const logger = createLogger();

const store = configureStore({
  reducer: {
    exam: examSlice.reducer,
    listening: listeningSlice.reducer,
    reading: readingSlice.reducer,
    writing: writingSlice.reducer,
    points: pointsSlice.reducer,
    user: userSlice.reducer
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware();
  },
});

export default store;
export const appDispatch = store.dispatch;
export type ReduxStateType = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
export { batch };
export const useAppSelector: TypedUseSelectorHook<
  ReturnType<typeof store.getState>
> = useSelector;
